import { Box, useDisclosure } from '@chakra-ui/react';
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import invariant from 'tiny-invariant';

import { TextSemiBold } from 'UiKit/typography';
import { StrollerIcon } from 'Asset/icon';
import { Condition } from 'Component/others';
import Tooltip from 'UiKit/tooltip';

import { useScheduleGenerateState } from 'View/schedule-generate/state';
import PopoverHandleHost from 'View/schedule-generate/component/popover-handle-host';

import styles from './styles.module.css';

const HostCard = ({ host, location, isAgency, cardWidth, isOpen, onToggle, onClose, state }) => {
  const { t } = useTranslation('schedule-generate');
  const { updateState, popupLocation, handleHost } = state;
  const ref = useRef();
  const [onDragging, setOnDragging] = useState(false);

  useEffect(() => {
    const el = ref.current;
    invariant(el);

    return draggable({
      canDrag: () => !isAgency,
      element: el,
      getInitialData: () => ({ host, location }),
      onDragStart: () => {
        setOnDragging(true);
      },
      onDrop: () => setOnDragging(false),
    });
  }, [location, host, isAgency]);

  const handleRightClick = (e) => {
    e.preventDefault();
    if (!isAgency) {
      onToggle();
      updateState({ popupLocation: location, handleHost: host });
    }
  };

  const isPopoverOpen =
    isOpen &&
    popupLocation[0] === location[0] &&
    popupLocation[1] === location[1] &&
    handleHost?.id === host?.id &&
    handleHost?.location[0] === location[0] &&
    handleHost?.location[1] === location[1];

  return (
    <PopoverHandleHost isOpen={isPopoverOpen} onClose={onClose}>
      <Box
        ref={ref}
        className={styles['host-card__container']}
        opacity={onDragging ? 0.7 : 1}
        backgroundColor={isAgency ? '#EDEDED' : host.bgColor}
        width={cardWidth}
        onContextMenu={handleRightClick}
        position={'relative'}
      >
        <TextSemiBold className={styles['host-card__text--name']}>
          <Tooltip label={isAgency ? t('hostCardAgency') : host?.name}>{isAgency ? t('hostCardAgency') : host?.name}</Tooltip>
        </TextSemiBold>

        <Condition statement={host?.isPregnancy}>
          <Box width={'20%'}>
            <StrollerIcon size="16px" color="var(--color-semantic-black)" data-testid="stroller-icon" />
          </Box>
        </Condition>
      </Box>
    </PopoverHandleHost>
  );
};

const MemoizedHostCard = (props) => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const state = useScheduleGenerateState();
  return useMemo(
    () => <HostCard {...props} isOpen={isOpen} onToggle={onToggle} onClose={onClose} state={state} /> /* eslint-disable */,
    [props?.host, props?.cardWidth, isOpen, state?.handleHost]
  );
};

export default MemoizedHostCard;
